import { DateTime } from 'luxon'
import Link from 'next/link'

import HeaderBar from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/HeaderBar'
import HeaderDate from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/HeaderDate'
import { SummarySaleReportProps } from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleReport/interface'
import LoadingGate from '@components/LoadingGate/LoadingGate'
import { showCommaFromString } from '@lib/utils'
import { SHOW_EBOOK_FEATURE } from '@configs/config'

const SummarySaleReport = ({
  isLoading,
  data,
  dateSelected,
}: SummarySaleReportProps) => {
  return (
    <LoadingGate isLoading={isLoading}>
      <div className='flex flex-col items-center justify-center mt-[20px]'>
        <HeaderBar className='mt-[30px]' title='สรุปรายงานการขาย' />
        <HeaderDate month={DateTime.fromJSDate(dateSelected.endDate)} />
        <div className='mt-[20px] grid grid-cols-2 font-[300]'>
          <div className='bg-blue-2 dark:bg-purple py-[16px] px-[20px] font-[500] text-sm dark:text-dark-10'>
            รายได้รวมของนักเขียน (ก่อนหักภาษี ณ ที่จ่าย)
          </div>
          <div className='bg-blue-2 dark:bg-purple py-[16px] px-[20px] font-[500] text-end dark:text-dark-10'>
            {showCommaFromString(data?.totalWriterIncome)} บาท
          </div>
          <div className='py-[16px] px-[20px] dark:text-dark-10'>
            1. รายได้จากนิยายรายตอน
          </div>
          <div className='py-[16px] px-[20px] dark:text-dark-10 text-end'>
            {showCommaFromString(data?.novelChapterSalesSummary)} บาท
          </div>
          <div className='py-[16px] px-[20px] dark:text-dark-10'>
            2. รายได้จากการ์ตูนรายตอน
          </div>
          <div className='py-[16px] px-[20px] dark:text-dark-10 text-end'>
            {showCommaFromString(data?.mangaChapterSalesSummary)} บาท
          </div>
          {SHOW_EBOOK_FEATURE ? (
            <>
              <div className='py-[16px] px-[20px] dark:text-dark-10'>
                3. รายได้จากอีบุ๊กนิยาย
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10 text-end'>
                {showCommaFromString(data?.novelEbookSalesSummary)} บาท
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10'>
                4. รายได้จากอีบุ๊กการ์ตูน
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10 text-end'>
                {showCommaFromString(data?.mangaEbookSalesSummary)} บาท
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10'>
                5. รายได้จากการสนับสนุน
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10 text-end'>
                {showCommaFromString(data?.donationSummary)} บาท
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10'>
                6. ยอดรายได้สะสมในเดือนที่แล้ว
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10 text-end'>
                {showCommaFromString(data?.totalWriterIncomeLastMonth)} บาท
              </div>
            </>
          ) : (
            <>
              <div className='py-[16px] px-[20px] dark:text-dark-10'>
                3. รายได้จากการสนับสนุน
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10 text-end'>
                {showCommaFromString(data?.donationSummary)} บาท
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10'>
                4. ยอดรายได้สะสมในเดือนที่แล้ว
              </div>
              <div className='py-[16px] px-[20px] dark:text-dark-10 text-end'>
                {showCommaFromString(data?.totalWriterIncomeLastMonth)} บาท
              </div>
            </>
          )}
        </div>

        <Link
          href='/my-writing?tab=salesAnalytics&subtab=payment-report'
          legacyBehavior
          prefetch={false}
        >
          <a className='mt-[40px] py-[9px] px-[20px] rounded-[150px] border-secondary dark:border-dark-10 dark:text-dark-10 border-[1px] text-sm font-mitr font-[500] cursor-pointer'>
            รายงานการจ่ายเงิน
          </a>
        </Link>
      </div>
    </LoadingGate>
  )
}

export default SummarySaleReport
